<template>
  <div class="economy-skeleton">
    <div class="economy-skeleton__header">
      <Skeleton width="200px" height="1.5rem" class="mb-2" />
      <Skeleton width="300px" height="1rem" />
    </div>

    <div class="economy-skeleton__content">
      <div class="economy-skeleton__left">
        <!-- Invoice list skeleton -->
        <div class="economy-skeleton__list">
          <div v-for="i in 3" :key="i" class="economy-skeleton__list-item">
            <div class="list-item-content">
              <Skeleton width="120px" height="1rem" class="mb-1" />
              <Skeleton width="80px" height="0.875rem" />
            </div>
            <div class="list-item-amount">
              <Skeleton width="100px" height="1.25rem" />
            </div>
          </div>
        </div>
      </div>

      <div class="economy-skeleton__right">
        <!-- Invoice recipient skeleton -->
        <div class="economy-skeleton__card">
          <Skeleton width="150px" height="1.25rem" class="mb-3" />
          <div class="card-details">
            <div v-for="i in 3" :key="i" class="detail-item">
              <Skeleton width="80px" height="1rem" />
              <Skeleton width="120px" height="1rem" />
            </div>
          </div>
        </div>

        <!-- Customer contact skeleton -->
        <div class="economy-skeleton__card">
          <Skeleton width="180px" height="1.25rem" class="mb-3" />
          <div class="card-details">
            <div v-for="i in 3" :key="i" class="detail-item">
              <Skeleton width="60px" height="1rem" />
              <Skeleton width="140px" height="1rem" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style lang="scss" scoped>
.economy-skeleton {
  &__header {
    margin-bottom: 2rem;
  }

  &__content {
    display: flex;
    gap: 2rem;
    max-width: 1060px;
    margin: auto;

    @media (max-width: $bp-md) {
      flex-direction: column;
      gap: 1.5rem;
    }
  }

  &__left {
    flex: 2;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    background: #fff;

    .list-item-content {
      flex: 1;
    }

    .list-item-amount {
      text-align: right;
    }
  }

  &__card {
    padding: 1.5rem;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;

    .card-details {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
